import { useEffect, useRef, useState, useCallback } from 'react';

/**
 * Sticky-sidebar guard. Returns a ref + canStick boolean.
 * Only stick when sidebar fits viewport with breathing room.
 */
export default function useStickySidebar() {
  const sidebarRef = useRef(null);
  const [canStick, setCanStick] = useState(true);

  const check = useCallback(() => {
    if (!sidebarRef.current) return;
    setCanStick(window.innerHeight > sidebarRef.current.offsetHeight + 80);
  }, []);

  useEffect(() => {
    check();
    window.addEventListener('resize', check);
    let ro;
    if (sidebarRef.current && typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(check);
      ro.observe(sidebarRef.current);
    }
    return () => {
      window.removeEventListener('resize', check);
      if (ro) ro.disconnect();
    };
  }, [check]);

  return { sidebarRef, canStick };
}
